import React from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import { Checkbox, Typography, Tooltip, IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { CalcGeneralProps } from "./CalculationMain";
import { MuiTimePicker } from "../framework/muiTimePicker";

export const CalcDailyAdditions = ({
    translate,
    handleChange,
    settings,
}: CalcGeneralProps) => {
    const {
        isSundayCalculationOn,
        isSundayEveningCalculationOn,
        isSundayNightCalculationOn,
        isSundayOrHolidaySpecificEveningCalculationOn,
        isSundayOrHolidaySpecificNightCalculationOn,
        sundaySpecificEveningWorkStartTime,
        sundaySpecificEveningWorkEndTime,
        sundaySpecificNightWorkStartTime,
        sundaySpecificNightWorkEndTime,
        isSaturdayCalculationOn,
        isSaturdayEveningCalculationOn,
        isEveningCalculationOn,
        isNightCalculationOn,
        saturdayStartTime,
        saturdayEndTime,
        isGrandHolidayDayCalculationOn,
    } = settings || {};

    return (
        <Grid2 container direction="column" spacing={2} p={3}>
            <Grid2>
                <Typography variant="h3">
                    {translate("dayAdditions")}
                </Typography>
            </Grid2>
            <Grid2>
                <label className={"field-width-normal"}>
                    <Checkbox
                        id="SATURDAYWORKON"
                        checked={isSaturdayCalculationOn}
                        onChange={(event) =>
                            handleChange(
                                "isSaturdayCalculationOn",
                                event.target.checked
                            )
                        }
                    />
                    {translate("SATURDAYWORKON")}
                </label>
            </Grid2>
            {isSaturdayCalculationOn ? (
                <>
                    <Grid2 xsOffset={2}>
                        <MuiTimePicker
                            label={translate("SATURDAYWORKSTARTTIME")}
                            value={saturdayStartTime}
                            onChange={(newValue) =>
                                handleChange("saturdayStartTime", newValue)
                            }
                        />
                    </Grid2>
                    <Grid2 xsOffset={2}>
                        <MuiTimePicker
                            label={translate("SATURDAYWORKENDTIME")}
                            value={saturdayEndTime}
                            onChange={(newValue) =>
                                handleChange("saturdayEndTime", newValue)
                            }
                        />
                    </Grid2>
                    {isEveningCalculationOn ? (
                        <Grid2 xsOffset={2}>
                            <label>
                                <Checkbox
                                    checked={isSaturdayEveningCalculationOn}
                                    onChange={(event) =>
                                        handleChange(
                                            "isSaturdayEveningCalculationOn",
                                            event.target.checked
                                        )
                                    }
                                />
                                {translate("saturdayEveningCalculationOn")}
                            </label>
                        </Grid2>
                    ) : null}
                </>
            ) : null}
            <Grid2>
                <label className={"field-width-normal"}>
                    <Checkbox
                        id="SUNDAYWORKON"
                        checked={isSundayCalculationOn}
                        onChange={(event) =>
                            handleChange(
                                "isSundayCalculationOn",
                                event.target.checked
                            )
                        }
                    />
                    {translate("SUNDAYWORKON")}
                </label>
            </Grid2>
            <Grid2>
                <label className={"field-width-normal"}>
                    <Checkbox
                        checked={isSundayOrHolidaySpecificEveningCalculationOn}
                        onChange={(event) =>
                            handleChange(
                                "isSundayOrHolidaySpecificEveningCalculationOn",
                                event.target.checked
                            )
                        }
                    />
                    {translate("sundaySpecificEveningCalculationOn")}
                </label>
            </Grid2>
            {isSundayOrHolidaySpecificEveningCalculationOn ? (
                <>
                    <Grid2 xsOffset={2}>
                        <MuiTimePicker
                            label={translate(
                                "sundaySpecificEveningWorkStartTime"
                            )}
                            value={sundaySpecificEveningWorkStartTime}
                            onChange={(newValue) =>
                                handleChange(
                                    "sundaySpecificEveningWorkStartTime",
                                    newValue
                                )
                            }
                        />
                    </Grid2>
                    <Grid2 xsOffset={2}>
                        <MuiTimePicker
                            label={translate(
                                "sundaySpecificEveningWorkEndTime"
                            )}
                            value={sundaySpecificEveningWorkEndTime}
                            onChange={(newValue) =>
                                handleChange(
                                    "sundaySpecificEveningWorkEndTime",
                                    newValue
                                )
                            }
                        />
                    </Grid2>
                    {isEveningCalculationOn ? (
                        <Grid2 xsOffset={2}>
                            <label>
                                <Checkbox
                                    checked={isSundayEveningCalculationOn}
                                    onChange={(event) =>
                                        handleChange(
                                            "isSundayEveningCalculationOn",
                                            event.target.checked
                                        )
                                    }
                                />
                                {translate("sundayEveningCalculationOn")}
                            </label>
                        </Grid2>
                    ) : null}
                </>
            ) : null}
            <Grid2>
                <label className={"field-width-normal"}>
                    <Checkbox
                        checked={isSundayOrHolidaySpecificNightCalculationOn}
                        onChange={(event) =>
                            handleChange(
                                "isSundayOrHolidaySpecificNightCalculationOn",
                                event.target.checked
                            )
                        }
                    />
                    {translate("sundaySpecificNightCalculationOn")}
                </label>
            </Grid2>
            {isSundayOrHolidaySpecificNightCalculationOn ? (
                <>
                    <Grid2 xsOffset={2}>
                        <MuiTimePicker
                            label={translate(
                                "sundaySpecificNightWorkStartTime"
                            )}
                            value={sundaySpecificNightWorkStartTime}
                            onChange={(newValue) =>
                                handleChange(
                                    "sundaySpecificNightWorkStartTime",
                                    newValue
                                )
                            }
                        />
                    </Grid2>
                    <Grid2 xsOffset={2}>
                        <MuiTimePicker
                            label={translate("sundaySpecificNightWorkEndTime")}
                            value={sundaySpecificNightWorkEndTime}
                            onChange={(newValue) =>
                                handleChange(
                                    "sundaySpecificNightWorkEndTime",
                                    newValue
                                )
                            }
                        />
                    </Grid2>
                    {isNightCalculationOn ? (
                        <Grid2 xsOffset={2}>
                            <label>
                                <Checkbox
                                    checked={isSundayNightCalculationOn}
                                    onChange={(event) =>
                                        handleChange(
                                            "isSundayNightCalculationOn",
                                            event.target.checked
                                        )
                                    }
                                />
                                {translate("sundayNightCalculationOn")}
                            </label>
                        </Grid2>
                    ) : null}
                </>
            ) : null}
            <Grid2>
                <label className={"field-width-normal"}>
                    <Checkbox
                        id="GRANDHOLIDAYON"
                        checked={isGrandHolidayDayCalculationOn}
                        onChange={(event) =>
                            handleChange(
                                "isGrandHolidayDayCalculationOn",
                                event.target.checked
                            )
                        }
                    />
                    {translate("grandHolidays")}
                    <Tooltip title={translate("grandHolidayHelper.day")}>
                        <IconButton disableRipple>
                            <InfoIcon color="primary" />
                        </IconButton>
                    </Tooltip>
                </label>
            </Grid2>
        </Grid2>
    );
};
